module.exports = __webpack_public_path__ + "static/media/quote-10-115-1000-2020-06-11_094744.117767.cfbe4724.pdf";